import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeFeaturedListComponent } from './badge-featured-list.component';
import { BadgeListItemModule } from '../badge-list-item/badge-list-item.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    BadgeFeaturedListComponent
  ],
  imports: [
    CommonModule,
    BadgeListItemModule,
    RouterModule
  ],
  exports: [
    BadgeFeaturedListComponent
  ]
})
export class BadgeFeaturedListModule { }
